import React from "react";
import WhatsAppFloat from "@/components/aevos/WhatsAppFloat";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import LpHeader from "./LpHeader";
import LpHero from "./LpHero";
import LpPain from "./LpPain";
import LpAuthority from "./LpAuthority";
import LpConsulta from "./LpConsulta";
import LpExames from "./LpExames";
import LpDiferenciais from "./LpDiferenciais";
import LpAcompanhamento from "./LpAcompanhamento";
import LpReviews from "./LpReviews";
import LpFaq from "./LpFaq";
import LpFinal from "./LpFinal";
import LpLocalizacao from "./LpLocalizacao";
import LpFooter from "./LpFooter";
import { LP_WA_MESSAGE } from "./lpData";

const LP_TITLE = "Emagrecimento com acompanhamento médico em Mogi das Cruzes | Dr. Guilherme Affonso — AEVOS";

export default function Emagrecimento() {
  useDocumentTitle(LP_TITLE);

  return (
    <div data-testid="lp-emagrecimento">
      <LpHeader />
      <main>
        <LpHero />
        <LpPain />
        <LpAuthority />
        <LpConsulta />
        <LpReviews />
        <LpExames />
        <LpDiferenciais />
        <LpAcompanhamento />
        <LpFaq />
        <LpFinal />
        <LpLocalizacao />
      </main>
      <LpFooter />
      <WhatsAppFloat message={LP_WA_MESSAGE} location="lp_float_button" />
    </div>
  );
}
